const ProfileIcon = (props) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.65366 7.89939C16.0406 -0.80898 27.2845 -2.5712 34.4682 3.8837C41.6519 10.3386 42.0336 28.1539 34.4682 36.0092C26.9028 43.8646 9.46587 41.3444 3.52835 36.0092C-2.40917 30.6741 -0.733297 16.6078 7.65366 7.89939Z"
      fill="#FB9318"
    />
    <g clipPath="url(#clip0)">
      <path
        d="M20.0013 12.2998C17.1442 12.2998 14.8086 14.598 14.8086 17.4095C14.8086 20.2209 17.1442 22.5191 20.0013 22.5191C22.8585 22.5191 25.1941 20.2209 25.1941 17.4095C25.1941 14.598 22.8585 12.2998 20.0013 12.2998Z"
        fill="white"
      />
      <path
        d="M28.913 26.6025C28.7769 26.2678 28.5955 25.9554 28.3915 25.6654C27.3484 24.1481 25.7384 23.144 23.9244 22.8985C23.6976 22.8762 23.4482 22.9208 23.2668 23.0547C22.3144 23.7464 21.1806 24.1034 20.0014 24.1034C18.8223 24.1034 17.6885 23.7464 16.7361 23.0547C16.5547 22.9208 16.3053 22.8539 16.0785 22.8985C14.2645 23.144 12.6318 24.1481 11.6114 25.6654C11.4073 25.9554 11.2259 26.2901 11.0899 26.6025C11.0219 26.7364 11.0445 26.8926 11.1126 27.0265C11.294 27.3388 11.5207 27.6512 11.7248 27.919C12.0422 28.343 12.3824 28.7222 12.7679 29.0792C13.0853 29.3916 13.4481 29.6817 13.811 29.9718C15.6024 31.2882 17.7566 31.9799 19.9788 31.9799C22.201 31.9799 24.3552 31.2882 26.1466 29.9718C26.5094 29.704 26.8722 29.3916 27.1897 29.0792C27.5525 28.7222 27.9153 28.3429 28.2328 27.919C28.4595 27.6289 28.6636 27.3388 28.845 27.0265C28.9583 26.8926 28.981 26.7364 28.913 26.6025Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="19.68"
          fill="white"
          transform="translate(10 12.2998)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ProfileIcon;
